export default "__VITE_ASSET__DMBeJ0c9__"